import { ErrorHandler, Inject, Injectable, Injector, NgZone } from "@angular/core";
import * as Sentry from "@sentry/angular";
import { ToastrService } from "ngx-toastr";
import { environment } from "src/environments/environment";
import { ErrorTypeEnum } from "./contract/error-handler.contract";

@Injectable({
  providedIn: "root",
})
/**
 * @description This service is used to show message data for UnprocessableContent errors and them send them to Sentry.
 */
export class ErrorHandlerService implements ErrorHandler {
  constructor(
    @Inject(Injector) private injector: Injector,
    private zone: NgZone,
  ) {}

  // Need to get ToastrService from injector rather than constructor injection to avoid cyclic dependency error
  private get toastrService(): ToastrService {
    return this.injector.get(ToastrService);
  }

  handleError(error: any): void {
    // Handle errors here before sending to Sentry

    const errorCode = error?.statusCode || error?.rejection?.statusCode;
    if (errorCode === ErrorTypeEnum.UnprocessableContent) {
      let errorMessage: string = "";
      if (error.rejection && error.rejection.detail && error.rejection.detail.message) {
        errorMessage = error.rejection.detail.message;
      }

      if (!!errorMessage) {
        this._showError(errorMessage);
      }
    } else {
      this._showError("Something went wrong. Please try again.");
      if (!environment.production) {
        console.error(error);
      }
    }

    // Send error to Sentry
    Sentry.captureException(error.originalError || error);
  }

  private _showError(errorMessage: string): void {
    this.zone.run(() => {
      this.toastrService.error(errorMessage);
    });
  }
}
